// extracted by mini-css-extract-plugin
module.exports = {"chart":"chart_TQg48"};